import { useMemo } from 'react'

import { Divider } from '~/app/component-library/components/Divider'
import {
  CurrencyAmount,
  LabelValue,
  List,
  TokenBalance,
  TokenDisplay,
} from '~/components/component-library'
import {
  SegmentedAssetsBar,
  Segment,
} from '~/components/component-library/SegmentedAssetsBar'
import { PositionBalance } from '~/components/smart-accounts/positions/types'
import { getPositionTypeLabel } from '~/components/smart-accounts/positions/utils'
import { getTokenColor } from '~/utils/tokens'

export const UniswapPositionDetailsContent = ({
  balance,
}: {
  balance: PositionBalance
}) => {
  const segmentValues: Segment[] = useMemo(() => {
    return balance.tokens.map((t) => ({
      name: t.symbol,
      color: getTokenColor(t.symbol),
      value: t.positionUsdValue ?? 0,
      items: [
        {
          symbol: t.symbol,
          address: t.address,
          chainId: balance.chainId,
          amount: t.positionAmount ?? 0n,
          value: t.positionUsdValue ?? 0,
        },
      ],
    }))
  }, [balance])

  return (
    <>
      <SegmentedAssetsBar
        totalValue={balance.positionUsdValue || 0}
        segments={segmentValues}
      />
      {balance.positionUsdValue && (
        <LabelValue
          label="Position size"
          value={
            <CurrencyAmount layout="inline" value={balance.positionUsdValue} />
          }
        />
      )}
      <Divider />
      <List
        label="Claimable fees"
        items={[
          ...balance.tokens.map((token, index) => ({
            key: `${token.address}-${index}`,
            content: (
              <TokenDisplay
                address={token.address}
                chainId={balance.chainId}
                layout="two-line"
                size="base"
                protocol={getPositionTypeLabel(balance.positionType)}
              />
            ),
            meta: (
              <TokenBalance
                address={token.address}
                chainId={balance.chainId}
                tokenAmount={token.claimableAmount}
                usdValue={token.feesUsdValue ?? undefined}
                isLoadingUsdValue={token.feesUsdValue === null}
                layout="standard"
                size="base"
                direction="neutral"
              />
            ),
          })),
        ]}
      />
    </>
  )
}
